var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkersDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    fill: "none",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#242938",
    rx: 60
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_107_922)",
    d: "M79.4225 40.5966L102.985 83.1058L81.346 122.056C80.3101 123.917 79.7664 126.01 79.7664 128.139C79.7664 130.269 80.3101 132.362 81.346 134.222L102.985 173.269L79.4225 215.778C74.9888 213.58 71.307 210.116 68.8433 205.824L31.3353 140.666C29.15 136.862 28 132.551 28 128.163C28 123.776 29.15 119.465 31.3353 115.661L68.8433 50.5026C71.3145 46.2287 74.9955 42.7819 79.4225 40.5966V40.5966Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_107_922)",
    d: "M81.346 122.104C80.3188 123.959 79.7798 126.044 79.7798 128.163C79.7798 130.283 80.3188 132.368 81.346 134.222L102.985 173.269L79.4225 215.778C74.9889 213.58 71.3071 210.116 68.8434 205.824L31.3353 140.666C28.3539 135.521 45.0402 129.366 81.346 122.153V122.104Z",
    opacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_107_922)",
    d: "M81.8269 44.8764L102.985 83.1058L99.4749 89.2128L80.8171 57.6195C75.4313 48.8196 67.2084 53.3878 56.9177 71.1801L58.4565 68.5353L68.8434 50.5026C71.2889 46.2427 74.9349 42.7973 79.3264 40.5966L81.7788 44.8764H81.8269Z",
    opacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_107_922)",
    d: "M187.138 50.5027L224.646 115.661C229.118 123.355 229.118 132.972 224.646 140.666L187.138 205.824C184.945 209.623 181.791 212.778 177.992 214.973C174.194 217.168 169.885 218.324 165.499 218.327H127.991L174.635 134.223C175.663 132.368 176.202 130.283 176.202 128.164C176.202 126.044 175.663 123.959 174.635 122.105L127.991 38H165.499C169.885 38.0028 174.194 39.1595 177.992 41.3541C181.791 43.5486 184.945 46.7037 187.138 50.5027V50.5027Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear_107_922)",
    d: "M163.575 218.039L126.548 218.375L171.365 133.838C172.367 131.958 172.891 129.861 172.891 127.731C172.891 125.601 172.367 123.503 171.365 121.624L126.548 38H135.011L182.041 121.239C183.155 123.205 183.737 125.429 183.729 127.689C183.72 129.949 183.122 132.168 181.993 134.126C171.871 151.718 161.821 169.35 151.842 187.022C142.705 203.083 146.649 213.422 163.575 218.039V218.039Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_linear_107_922)",
    d: "M90.4827 218.327C86.6357 218.327 82.7887 217.413 79.4226 215.778L125.683 132.347C127.125 129.75 127.125 126.577 125.683 123.98L79.4226 40.5967C82.8612 38.894 86.6456 38.0055 90.4827 38H127.991L174.635 122.105C175.663 123.959 176.202 126.044 176.202 128.164C176.202 130.283 175.663 132.368 174.635 134.223L127.991 218.327H90.4827Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint6_linear_107_922)",
    d: "M171.365 123.98L123.663 38H127.991L174.635 122.105C175.663 123.959 176.202 126.044 176.202 128.164C176.202 130.283 175.663 132.368 174.635 134.223L127.991 218.327H123.663L171.365 132.347C172.808 129.75 172.808 126.577 171.365 123.98V123.98Z",
    opacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint7_linear_107_922)",
    d: "M125.683 123.98L79.4226 40.5968C80.8652 39.8274 82.5964 39.2503 84.2313 38.7694C94.4258 57.0907 109.477 84.8851 129.433 122.105C130.461 123.959 131 126.044 131 128.164C131 130.283 130.461 132.368 129.433 134.223L83.51 217.365C81.8751 216.885 81.0095 216.548 79.4707 215.827L125.634 132.395C127.077 129.799 127.077 126.625 125.634 124.028L125.683 123.98Z",
    opacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_107_922",
    x1: 65.493,
    x2: -11.309,
    y1: 215.778,
    y2: 92.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB6F07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB743"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_107_922",
    x1: 89.307,
    x2: 49.763,
    y1: 200.51,
    y2: 159.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D96504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D96504",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_107_922",
    x1: 76.266,
    x2: 97.2,
    y1: 44.826,
    y2: 78.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB6F07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB720A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_107_922",
    x1: 177.995,
    x2: 109.226,
    y1: 218.327,
    y2: 75.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE6F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB743"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_107_922",
    x1: 107.564,
    x2: 217.671,
    y1: 218.375,
    y2: 190.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D96504",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#D96504",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D96504",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_107_922",
    x1: 127.812,
    x2: 57.639,
    y1: 218.327,
    y2: 76.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEBC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_107_922",
    x1: 127.918,
    x2: 186.439,
    y1: 39.984,
    y2: 49.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_107_922",
    x1: 72.357,
    x2: 144.69,
    y1: 224.866,
    y2: 214.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkersDark);
export default __webpack_public_path__ + "static/media/Workers-Dark.e06ee7298cab91ed400a26e54cb0edba.svg";
export { ForwardRef as ReactComponent };